
import { useEffect } from 'react';

import './Home.css';

import NavBar from '../../Component/NavBar/NavBar';

import FirstShow from '../../Component/FirstShow/FirstShow';
import Projects from '../../Component/Projects/Projects';
import Experience from '../../Component/Experince/Experince';
import About from '../../Component/About/About';
import Skils from '../../Component/Skils/Skils';
import Footer from '../../Component/footer/Footer';

function Home() {

    // Scroll to top when entering Portfolio
    useEffect(() => {
        if (!window.location.hash) {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant'
            });
        }
    }, []);

    return (
        <>
            <NavBar />

            {/* HERO */}
            <div id="home">
                <FirstShow />
            </div>

            {/* SELECTED PROJECTS */}
            <Projects />

            {/* WORK EXPERIENCE */}
            <div id="experience">
                <Experience />
            </div>

            {/* ABOUT ME */}
            <div id="about">
                <About />
            </div>

            {/* SKILLS */}
            <div id="skills">
                <Skils />
            </div>

            {/* CONTACT */}
            <div id="contact">
                <Footer />
            </div>
        </>
    );
}

export default Home;
